<script>
import FluentIcon from 'shared/components/FluentIcon/Index.vue';

export default {
  name: 'ContactLimitWarning',
  components: {
    FluentIcon,
  },
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dismissed: false,
    };
  },
  computed: {
    warningInfo() {
      const info = this.account.contact_limit_warning || {};
      return info;
    },
    showWarning() {
      const shouldShow = this.warningInfo.show && !this.dismissed;
      return shouldShow;
    },
    warningMessage() {
      return this.warningInfo.message;
    },
    warningType() {
      return this.warningInfo.type || 'warning';
    },
  },
  mounted() {
    // Check if user has dismissed the warning recently
    const dismissedTime = localStorage.getItem(
      'contact_limit_warning_dismissed'
    );
    if (dismissedTime) {
      const dismissedDate = new Date(parseInt(dismissedTime));
      const hoursSinceDismissed =
        (Date.now() - dismissedDate.getTime()) / (1000 * 60 * 60);
      // Show again after 24 hours
      if (hoursSinceDismissed < 24) {
        this.dismissed = true;
      }
    }
  },
  methods: {
    upgradeAccount() {
      // Navigate to upgrade page or open upgrade modal
      if (this.warningInfo.upgrade_url) {
        window.location.href = this.warningInfo.upgrade_url;
      }
    },
    dismissWarning() {
      this.dismissed = true;
      // Optionally store dismissal in localStorage
      localStorage.setItem(
        'contact_limit_warning_dismissed',
        Date.now().toString()
      );
    },
  },
};
</script>

<template>
  <div v-if="showWarning" class="contact-limit-warning">
    <div class="warning-banner" :class="warningType">
      <div class="warning-content">
        <div class="warning-icon">
          <FluentIcon v-if="warningType === 'error'" icon="alert" size="20" />
          <FluentIcon v-else icon="warning" size="20" />
        </div>
        <div class="warning-message">
          {{ warningMessage }}
        </div>
        <div class="warning-actions">
          <button class="upgrade-button" @click="upgradeAccount">
            Upgrade Plan
          </button>
          <button class="dismiss-button" @click="dismissWarning">
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.contact-limit-warning {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.warning-banner {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.warning-banner.warning {
  background: linear-gradient(135deg, #ff9800, #ff5722);
  color: white;
}

.warning-banner.error {
  background: linear-gradient(135deg, #f44336, #d32f2f);
  color: white;
}

.warning-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  width: 100%;
  gap: 20px;
}

.warning-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.warning-message {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.warning-actions {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.upgrade-button {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.upgrade-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.dismiss-button {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dismiss-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 768px) {
  .warning-content {
    flex-direction: column;
    gap: 12px;
  }

  .warning-actions {
    width: 100%;
    justify-content: center;
  }
}
</style>
